module.exports = __webpack_public_path__ + "static/media/spot.68e43376.svg";